<template>
    <v-container class="pa-0 ma-0" fluid id="mainhomecontainer" >
        <v-card class="overview" elevation="0">
            <v-overlay v-model="overlay"
                :color= "storeBusiness.themecolor!=NULL?storeBusiness.themecolor:'#FE5800'" >
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card class="d-md-none">
                <v-card min-height=100>
                    <v-row align="start" justify="center" class="maxtall" >
                        <v-card class="pl-1 pr-1">
                            <v-container pa-0>
                                <v-col cols="12" sm="12" md="12" no-gutters>
                                    <v-card class="pl-2 pr-2 ml-2 mr-2">
                                        <p class="text-center pt-5 pb-5 ">Sorry, Drag & Drop is only avilable on a desktop computer at this time...<br>If you are working on a desktop computer, increase the size of the window to use Drag & Drop</p>
                                    </v-card>
                                </v-col>
                            </v-container>
                        </v-card>
                    </v-row>
                </v-card>
            </v-card>
<!-- DRAG & DROP EXPLINATION BUTTON  -->
            <v-row class="d-none d-md-flex " justify="right">
                <v-col cols="12" class="text-left">
                    <!-- <v-btn color="primary" class="ml-3 " -->
                     <v-row>
                        <div class="pl-11">
                            <v-dialog
                            v-model="dialog"
                            width="800"
                            v-bind="attrs"
                            v-on="on">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    elevation="2"
                                    color="#FE5800"
                                    fab
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        <v-icon color="white">mdi-information-variant</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="section-spread text-h1 zzorganebg">
                                        <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-drag-variant</v-icon>{{$t('zz_drag_and_drop_title')}}</h1>
                                    </v-card-title>
                                    <p class="pt-5 px-4">
                                        <span v-html="$t('zz_drag_and_drop_explination')">
                                        </span>
                                    </p><br>
                                    <v-divider></v-divider>
                                    <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                </v-card>
                            </v-dialog>
<!-- ADD NEW ITEM BUTTON                              -->
                        </div>
                        <!-- <v-btn color="primary" class="ml-3" @click="$router.push({name:'createcourse'})">{{$t('zz_create_course')}}</v-btn> -->
                        <v-btn color="#FE5800" class="ml-3" style="color:white" @click="createcoursenew">{{$t('zz_create_course')}}<v-icon class="pl-2">mdi-plus-circle-outline</v-icon></v-btn>

                        <v-btn color="#FE5800" class="ml-3" style="color:white" @click="createfooditem">{{$t('zz_create_food_item')}}<v-icon class="pl-2">mdi-plus-circle-outline</v-icon></v-btn>
                        <!-- <v-btn color="#FE5800" class="ml-3" @click="createfooditem">{{$t('zz_add_food_item')}}<v-icon class="pl-2">mdi-plus-circle-outline</v-icon></v-btn> -->
                        <!-- <v-btn elevation="10" color="#FE5800" class="bounce ml-3" v-if="isdragged" @click="savemenu" >
                            {{$t('zz_save_food_menu_changes')}}
                        </v-btn>
                        <span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">
                            {{savemsg}}
                        </span> -->
                    </v-row>
                </v-col>
            </v-row>
<!-- END DRAG & DROP EXPLINATION BUTTON                  -->
            <v-card-text  class="d-none d-md-flex" style="width:100%;overflow-x:scroll;height:1500px;">
              <div  class="overflowcol">
                    <draggable v-model="fooditems.courses" @start="drag=1" @end="dragfooditem('c')" >

                        <transition-group>

                           <div class="maxtall course_col" :class="drag?move:''" v-for="course in fooditems.courses" :key="'c-'+course.id">
                             <!-- <v-card elevation="12" class="course-heading-card"> -->
                               <!-- <div class="tooltip"><img :src="swipe-l-r" width="30px"> <span class="tooltiptext">España</span></div> -->
                               <!-- <span class="left-right-arrow"> ↔ {{$t('zz_drag-left-right-arrow')}}</span> -->

                               <v-card elevation="1" :class="[course.status?'course-heading-card':'course-heading-card-inactive']">
<!-- COURSE HEADING                                  -->

                                <template>
                                  <v-row style="top:4px; right:4px; position:absolute; z-index=9" class="align-end pl-0 pr-0">
                                    <v-menu transition="fab-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn @click.stop float-right color="#FE5800" icon v-bind="attrs" v-on="on">
                                            <!-- <v-icon style="top:0px; right:0px; position:absolute; z-index=9999" class="compact-cogs-75 white-cog">fa fa-cogs</v-icon> -->
                                            <v-icon class="cog-position-1 compact-cogs-75 white-cog">fa fa-cogs</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                        <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-3">
                                            mdi-close-circle
                                        </v-icon>
                                        <v-list-item>
                                            <span class="edit-item-name">{{course.name}}</span>
                                        </v-list-item>
                                        <v-list-item>
                                        <div cols="12" v-if="course.status==1">
                                            <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="shw"  @click="updatebusinesscourse(course.id,0)"></v-switch>
                                        </div>
                                        <div cols="12" v-else>
                                            <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="nshw"  @click="updatebusinesscourse(course.id,1)"></v-switch>
                                        </div>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </v-row>
                                </template>
                                  <v-row>
                                    <v-col cols="12" class="pa-0 text-right">
                                      <v-card-text  class="white--text ma-0 pa-0 pl-1 pr-1 py-2">
                                        <p class="courseheading ma-0 pa-0 sticky-course-heading">
                                          {{course.name}}
                                        </p>
                                      </v-card-text>
                                    </v-col>
                                  </v-row>
                              </v-card>

<!-- BANNER CONTENT SECTION  -->
                              <v-card elevation="0" :class="[course.status?'course-banner-card':'course-banner-card-inactive hidden-course']">
                                <template>
                                  <v-row style="top:4px; right:4px; position:absolute; z-index=9" class="pl-0 pr-0" v-if="course.price || course.pricetext || course.description">
<!-- COGS  -->
                                    <v-menu transition="fab-transition">
                                      <template v-slot:activator="{ on, attrs }">
                                        <div >
                                        <v-btn @click.stop float-right color="#FE5800" icon v-bind="attrs" v-on="on">
                                            <!-- <v-icon style="top:0px; right:0px; position:absolute; z-index=9999" class="compact-cogs-75 white-cog">fa fa-cogs</v-icon> -->
                                            <v-icon class="cog-position-1 compact-cogs-75">fa fa-cogs</v-icon>
                                        </v-btn>
                                        </div>

                                      </template>
                                      <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                        <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-3">
                                            mdi-close-circle
                                        </v-icon>
                                        <!-- <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1"> -->
                                        <v-list-item>
                                            <span class="edit-item-name">{{$t('zz_course_information')}}</span>
                                        </v-list-item>
                                        <v-list-item>
                                        <div cols="12" v-if="course.showon==1">
                                            <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="shw"  @click="updatebusinessshowon(course.id,0)"></v-switch>
                                        </div>
                                        <div cols="12" v-else>
                                            <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" :input-value="nshw"  @click="updatebusinessshowon(course.id,1)"></v-switch>
                                        </div>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-btn icon @click="editItem(course.id)" color="#FE5800 " fab x-small dark
                                                class="mt-2 mb-2">
                                                <v-icon>mdi-square-edit-outline</v-icon>
                                            </v-btn>
                                        </v-list-item>
                                      </v-list>

                                      </v-menu>
                                  </v-row>
                                  <v-row class="" v-else>
                                              <v-col cols="12" class="text-right">
                                          <v-btn
                                            color="#FE5800" class="px-3"
                                            style="color:white"
                                            @click="editItem(course.id)">
                                            {{$t('zz_add_course_heading')}}
                                            <v-icon>mdi-plus-circle-outline</v-icon>
                                          </v-btn>
                                              </v-col>
                                            </v-row>
<!-- END OF COGS  -->
                              </template>
<!-- BANNER CONTENT   -->
                 <div :class="!course.showon? 'hidden-course':''">
                                <v-row>
                                  <v-col col="12" md="12" class="food-course-top-banner-price pt-2">
                                    <!-- v-if="item.item.showonmenu==1" -->
                                      <!-- <span>{{course.price}}</span> -->
                                      <span v-html="course.price"></span>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col col="12" md="12" class="food-course-top-banner-price-text">
                                        <!-- <span>{{course.pricetext}}</span> -->
                                        <span v-html="course.pricetext"></span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col col="12" md="12" class="food-course-top-banner-description">
                                        <span v-html="course.description"></span>
                                    </v-col>
                                </v-row>
                                </div>
                              </v-card>
<!-- ADD NEW ITEM TO TOP OF FOOD LIST   -->
                                <div class="mt-12"></div>
                                <v-row>
                                  <div cols=12 md="12"  class="addnew text-right pb-5 pr-4" >
                                    <div @click="cfooditem(course.id)">
                                    <!-- <div @click="editFoodItem(0)"> -->

                                      <span class="addnew text-right" :class="course.status==0?'hidden-course':''">
                                        {{$t('zz_add_food_item')}}
                                      </span>
                                      <v-icon class="pb-1 addnewicon" :class="course.status==0?'hidden-course':''">mdi-plus-circle-outline</v-icon>
                                      <v-divider role="presentation" class="pl-1 text-center" style="width:95%; margin-left: 13px"></v-divider>
                                    </div>
                                  </div>
                                </v-row>

                                <v-card-content>
                                    <draggable @start="dragitem=1;" @end="dragfooditem('i');" v-model="course.itemcourses">
                                        <transition-group>



                                            <v-card elevation="24" class="mb-3 maxtall" :class="[item.item.sepretor==1?'seperator':'' , item.item.foodstatus=='Feature'? 'featueredDnD':'', course.status==0?'hidden-course':'']" v-for="(item,index) in course.itemcourses" :key="'fd-'+item.id">
                                                <div>
                                                <v-row clos="12" md="12" no-gutters class="ma-0 pa-0">
                                                    <v-row no-gutters class="pt-0 pb-0 pl-0 section-spread">
                                                       <!-- <v-col cols="4" md="4" class="pt-0 pb-0 pl-0" v-if="item.item.sepretor==0"> -->
<!-- Image  -->
                                                          <v-col :cols="item.item.hasimage==1?4:12" class="pt-0 pb-0 pl-0" v-if="item.item.sepretor==0">
                                                            <container jusitfy:start>
                                                                <v-img height="100" class="dnd-card-height pl-0 pt-0 pb-0 pr-1"  v-if="item.item.sepretor==0 && item.item.hasimage" :class="item.item.showonmenu==0? 'inactiveimg':''"
                                                                    :src="item.item.fimage" />
                                                            </container>
                                                            <div no-gutters class="ma-0 pl-0 pt-0 pb-0">
                                                            <img :src="cheficonList" v-if="item.item.foodstatus=='From Chef'" class="cheficonDnD"/>
                                                            </div>
                                                        </v-col>
<!-- v-if="course.status==1" class="inactiveimg" -->
<!-- :class="item.item.hasimage==0? 'centered-text':''" -->
<!-- ACTIVE TEXT & IMAGES  -->
                                                        <v-col v-if="item.item.showonmenu==1" cols="6" md="6" class="pt-2 pb-2 pl-5">
                                                            <v-row class="food-title-dnd" :class="item.item.sepretor?'white-text-heading':''">
                                                                <span class="d-inline-block text-truncate" style="max-width: 150px;">
                                                                <v-card-text class="ma-0 pa-0 text-truncate">
                                                                    {{item.item.title}}
                                                                </v-card-text>
                                                                </span>
                                                            </v-row>

                                                            <v-row v-if="item.item.sepretor==0" class="food-subtitle-dnd">
                                                              <span
                                                                  class="d-inline-block text-truncate"
                                                                  style="max-width: 150px;"
                                                                >
                                                                <v-card-text class="ma-0 pa-0 text-truncate">
                                                                    {{item.item.subtitle}}
                                                                </v-card-text>
                                                                </span>
                                                            </v-row>
                                                        </v-col>

<!-- GREY OUT INACTIVE ITEM TEXT  -->
                                                        <v-col v-else cols="6" md="6" class="pt-1 pb-2 pl-5">
                                                            <v-row class="food-title-dnd-hidden" :class="item.item.sepretor?'hidden-text-heading':''">
                                                                <v-card-text class="ma-0 pa-0 text-truncate">
                                                                    {{item.item.title}}
                                                                </v-card-text>
                                                            </v-row>
                                                            <v-row v-if="item.item.sepretor==0" class="food-subtitle-dnd-hidden">
                                                                <v-card-text class="ma-0 pa-0 text-truncate">
                                                                    {{item.item.subtitle}}
                                                                </v-card-text>
                                                            </v-row>
                                                        </v-col>


<!-- Cogs and Edit Menu -->                             <v-col no-gutters cols="2" md="2" class="alignrigth pr-0">
                                                            <v-menu bottom right transition="fab-transition">
                                                                <template v-slot:activator="{ on, attrs }" class="pa-0 ma-0">
                                                                    <v-btn no-gutters class="pa-0 ma-0" color="#FE5800" icon v-bind="attrs" v-on="on">
                                                                        <!-- <v-icon>fa fa-cog fa-spin</v-icon> -->
                                                                        <v-icon no-gutters class="compact-toggle-dnd-1" :class="item.item.showonmenu==0? 'inactivecogsimg':'' ">fa fa-cogs</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1">
                                                                    <v-icon color="red" icon dark class="close-menu-left pa-0 ma-0 pt-2 pl-3">
                                                                        mdi-close-circle
                                                                    </v-icon>
                                                                    <!-- <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1"> -->
                                                                    <v-list-item>
                                                                        <span class="mt-4 edit-item-name">{{item.item.title}}</span>
                                                                    </v-list-item>
                                                                    <v-list-item>
        <!-- TOGGLE SWITCH SHOW OR HIDE ITEM  -->                       <div cols="12" v-if="item.item.showonmenu==1 ">
                                                                        <v-switch class="pl-1 compact-toggle-dnd-1" inset color="success" v-model="item.item.showonmenu" :input-value="shw"  @click="updateshowitem(item.item.id,item.course_id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                                    <div v-else>
                                                                        <v-switch class="pl-1 compact-toggle-dnd-1" inset color="red" v-model="item.item.showonmenu" :input-value="nshw"  @click="updateshowitem(item.item.id,item.course_id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                                    </div>
                                                                    </v-list-item>
                                                                    <v-list-item v-if="item.item.sepretor==0">
                                                                        <v-btn icon @click.prevent="fooditemimage(item.item.id,item.course_id,item.item.showonmenu)" color="#FE5800 " fab x-small dark class="mt-2 mb-2">
                                                                            <v-icon>mdi-camera-plus-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item v-if="item.item.sepretor==0">
                                                                        <v-btn icon @click.stop="foodstatusupdate(item.item.id,'From Chef')" color="#FE5800 " fab x-small dark
                                                                            class="mt-2 mb-2">

                                                                            <v-icon>mdi-chef-hat</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item v-if="item.item.sepretor==0">
                                                                        <v-btn icon @click.stop="foodstatusupdate(item.item.id,'Feature')" color="#FE5800 " fab x-small dark
                                                                            class="mt-2 mb-2">
                                                                            <v-icon>mdi-star-shooting-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item>
                                                                        <v-btn icon @click="editFoodItem(item.item.id)" color="#FE5800 " fab x-small dark
                                                                            class="mt-2 mb-2">
                                                                            <v-icon>mdi-square-edit-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                    <v-list-item>
                                                                        <v-btn icon @click="deleteItemCourse(item.item.id)" color="#FE5800 " fab x-small dark class="">
                                                                            <v-icon>mdi-trash-can-outline</v-icon>
                                                                        </v-btn>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                                </div>
                                            </v-card>
                                        </transition-group>
                                    </draggable>
                                </v-card-content>
                                <v-row>
                                  <div cols=12 md="12"  class="addnew text-right pt-5 pr-4">
                                    <div @click="cfooditem(course.id)">
                                      <v-divider role="presentation" class="text-center" style="width:95%; margin-left: 13px; margin-bottom:5px"></v-divider>
                                      <span class="addnew text-right" :class="course.status==0?'hidden-course':''">
                                        {{$t('zz_add_food_item')}}
                                      </span>
                                      <v-icon class="pb-1 addnewicon" :class="course.status==0?'hidden-course':''">mdi-plus-circle-outline</v-icon>
                                    </div>
                                  </div>
                                </v-row>

                           </div>

                        </transition-group>
                    </draggable>
              </div>

<!-- CHANGE update IMAGE DIALOG  -->
              <v-dialog v-model="itemimagedialog" content class="itemdetaildialog card-in-cards-container true-center" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card tile class="true-center" elevation="3" color="#fff"   >
                    <v-container class="true-center cards-container">
                      <v-container class="ma-0 pa-0">
                        <v-card elevation="24" class="cards-container" >
                          <v-col class="pa-0 ma-0">

                            <v-row v-if="!mainimguploading" no-gutters class="true-center ma-0 pa-0">
                              <v-img
                                  lazy-src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                                  width=""
                                  src="https://cdn.vuetifyjs.com/images/parallax/material.jpg">

                                <v-btn class="edit-food-photo-icon" style="position:absolute; top:47%; left:47%; color:#fff" icon @click="$refs.file.click()">
                                  <v-icon style="font-size:50px">mdi-image-plus</v-icon>
                                </v-btn>
                              </v-img>
                            </v-row>
                            <v-row v-if="mainimguploading">
                              <v-col cols="12" class="text-center">
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </v-col>
                            </v-row>

                            <span style="position:absolute; top:25%; left:25%;">
                              <Cropper v-show="uploadedimage!=null && uploadedimage!='null'" class="cropper-replace" :src="uploadedimage" @change="onChange"/>
                            </span>

                            <!-- <v-btn color="primary" block large @click.stop="updateimage">
                              {{$t('zz_save_drink_menu_changes')}}
                            </v-btn> -->
                          </v-col>
                        </v-card>
                        </v-container>
                        <v-col cols="12" class="">
                        <input type="file" ref="file" @change="uploadImage($event)" accept="image/*" class="d-none" id="itemimage"/>
                        </v-col>
                    </v-container>

                    <v-card class="">
                    <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">
                        <v-form v-model="valid" enctype="multipart/form-data" id="editfooditem">
                        <container >



                        </container>
                        </v-form>
                    </v-card-text>
                    </v-card>
                </v-card>
                <v-footer padless fixed class="footer-1">
                  <v-row no-gutters>
                  <v-col cols="12">
                    <v-btn class="px-10 ma-5" color="primary" elevation="21" x-large  @click.stop="updateimage">{{$t('zz_save_and_exit')}}</v-btn>
                      <v-btn class="px-10 ma-5" elevation="1" plain large @click="backtomenuimage">{{$t('zz_exit')}}</v-btn>
                  </v-col>
                </v-row>
              </v-footer>
                <!-- <v-footer
                    absolute
                    class="font-weight-medium "
                    color="transparent">
                        <v-col
                            class="text-center"
                            cols="12"
                        >
                            <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                                <v-icon class="white--text ">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                </v-footer> -->
              </v-dialog>


              <v-dialog v-model="createitem" content-class="createitemdialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

                <v-card v-if="createitem==true" tile class="" elevation="3" color="#fff">
                    <CreateFoodItem  v-on:set-dialog="backtolist" :cid="cid"/>
                </v-card>



              </v-dialog>


              <v-dialog v-model="edititemdialog" content-class="createitemdialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">

                <v-card v-if="edititemdialog==true" tile class="" elevation="3" color="#fff">
                    <EditFoodItem  v-on:set-dialog="backtolist" :editfooditemid="editfooditemid"/>
                </v-card>




              </v-dialog>

              <v-dialog v-model="courseeditdialog" content-class="createitemdialog" fullscreen hide-overlay transition="dialog-bottom-transition">

                <v-card v-if="courseeditdialog==true" tile class="" elevation="3" color="#fff">
                    <CourseEdit  v-on:set-dialog="backtolist" :cid="cid"/>
                </v-card>





              </v-dialog>

              <v-dialog v-model="createcoursedialog" content-class="createitemdialog"  fullscreen hide-overlay transition="dialog-bottom-transition">

                <v-card v-if="createcoursedialog==true" tile class="" elevation="3" color="#fff">
                    <CourseCreate  v-on:set-dialog="backtolist" :cid="cid"/>
                </v-card>



              </v-dialog>

            </v-card-text>
        </v-card>
<v-footer padless fixed  class="footer-1" style="z-index: 100;">
  <!-- <v-container> -->
    <!-- <v-row class="d-none d-md-flex " justify="right"> -->
                <!-- <v-col cols="12" class="text-left"> -->
                    <!-- <v-btn color="primary" class="ml-3 " -->
                     <v-row no-gutters>
                        <v-btn color="primary" elevation="21" x-large class="bounce px-10 ma-5" v-if="isdragged" @click="savemenu" >
                            {{$t('zz_save_food_menu_changes')}}
                        </v-btn>
                        <span class="ml-3 success--text font-weight-bold" v-if="savemsg!=''">
                            {{savemsg}}
                        </span>
                    </v-row>
                <!-- </v-col> -->
            <!-- </v-row> -->
  <!-- </v-container> -->

          <!-- <v-row no-gutters>
          <v-col cols="12">
            <v-btn class="px-10 ma-5" color="primary" elevation="21" x-large  @click.prevent="submit('exit');$emit('set-dialog');">{{$t('zz_save_and_exit')}}</v-btn>
              <v-btn class="px-10 ma-5" elevation="1" plain large @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>
          </v-col>
        </v-row> -->
        </v-footer>
    </v-container>
</template>
<script>
import Vue from "vue";
import draggable from "vuedraggable";
import { Cropper } from 'vue-advanced-cropper';
import CreateFoodItem from '@/components/FoodItemCreate.vue';
import EditFoodItem from '@/components/FoodItemEdit.vue';
import CourseEdit from '@/components/CourseEdit.vue';
import CourseCreate from '@/components/CourseCreate.vue';


export default {
  props: {
    source: String,
  },
  data: () => ({
          createcoursedialog:false,
          createitem:false,
          mainimguploading:false,
          uploadedimage:null,
          overlayfooditemimageupdate:false,
          image:null,
          shw:true,
          nshw:false,
          switchValue:false,
          showonitem:true,
          headers: [
          {
            text: 'Photo',
            align: 'start',
            sortable: false,
            value: 'photo',
          },
          { text: 'Title', value: 'title' },
          { text: 'Viewed', value: 'viewed' },
          { text: 'Favorites', value: 'favorites' },
          { text: '%', value: 'per' },
          { text: 'Special', value: 'special' },
          { text: 'Price', value: 'price' },
          { text: 'Section', value: 'section' },

        ],

      foodview:'grid',

      savemsg:'',
      isdragged:0,
      dragitem:0,
      drag:0,
      overlay: false,

      juzzapLogo: require("@/assets/logo-Copy.png"),
      cheficonGrid:require('@/assets/chefGrid.svg'),
      cheficonList:require('@/assets/chefList.svg'),
      // swipe-l-r:require('@/assets/swipe-left-right.svg'),

    id:'',
    items: [],
    coursesall: [],
    itemimg: "",
    fooditems: {
      courses: [],

    },
    itemimagedialog:false,
    valid:true,
    cid:"",
    edititemdialog:false,
    courseeditdialog:false,

  }),
  components: {
    draggable,
    Cropper,
    CreateFoodItem,
    EditFoodItem,
    CourseEdit,
    CourseCreate,
  },
  created() {
    this.storeBusiness = JSON.parse(localStorage.getItem("business"));

    //    if (this.$route.params.id) {
    //   this.id = this.$route.params.id
    //    }

    this.id = this.storeBusiness.id;

    this.overlay = true;

    this.$http
      .get(this.$apidomain + "itemlistnew/" + this.id)
      .then((res) => {
        if (res.data.success == 0) {
          //this.$router.push({name:'businesslistnew'});
        }
      })
      .catch((err) => {
        console.log(err.response);
      });

    this.$http
      .get(this.$apidomain + "itemlist/" + this.id)
      .then((res) => {
        if (res.data.success == 0) {
          //this.$router.push({name:'businesslistnew'});
        }
        this.items = res.data.items;
        this.$http
          .get(this.$apidomain + "getfooditems/" + this.id)
          .then((res) => {
            if (res.data.success == 0) {
              //this.$router.push({name:'businesslistnew'});
            }
            this.fooditems = res.data.fooditems;
            this.overlay = false;
          })
          .catch((err) => {
            console.log(err.response);
            this.overlay = false;
          });
        // this.overlay=false;
      })
      .catch((err) => {
        console.log(err.response);
        this.overlay = false;
      });

    // this.getBusiness();
  },
  methods:
  {
        foodstatusupdate(itemid,foodstatus)
        {

                this.$http
                .post(this.$apidomain+"itemfoodstatusupdate/"+itemid,{foodstatus:foodstatus})
                .then(res => {
                    if(res.data.success==1)
                    {


                        this.$router.go('/');
                    }



                })
                .catch(err => {
                    console.log(err.response);
                    //this.overlay=false;

                });

        },
        backtolist()
        {
          this.createitem=false;
          this.edititemdialog=false;
          this.courseeditdialog=false;
          this.createcoursedialog=false;

        },
        createcoursenew()
        {
          this.createcoursedialog=true;
        },
        createfooditem()
        {
          // this.$router.push({name:'createfooditem',params:{id:this.storeBusiness.id}});

          this.createitem=true;
        },
        // createfooditem() {
        //   this.$router.push({name: "createfooditem",params: { id: this.storeBusiness.id}});
        // },
        cfooditem(courseid)
        {

          // this.$router.push({name:'createfooditem',params:{cid:courseid}});
          this.cid=courseid;

          localStorage.setItem('cid',this.cid);
          this.createitem=true;
        },

        editItem(courseid)
        {

          this.cid=courseid;
          this.courseeditdialog=true;
          // this.$router.push({name:'editcourse',params:{id:courseid}});

          // this.createitem=false;
          // this.edititemdialog=true;

        },
        editFoodItem(fooditemid)
        {
          // this.$router.push({
          //   name: "editfooditem",
          //   params: { id: fooditemid, business_id: this.storeBusiness.id },
          // });
          this.editfooditemid=fooditemid;
          // alert(this.editfooditemid);
          this.createitem=false;
          this.edititemdialog=true;

        },
        createcourse(courseid)
        {
            this.$router.push({name:'createcourse',params:{cid:courseid}})
        },

        updatebusinesscourse(courseid,showstatus)
        {
            this.$http

          .post(this.$apidomain+"updatebusinesscoursestatus/"+courseid+'/'+this.id,{showstatus:showstatus})
          .then(res => {
            //this.businesses = res.data.businesses;
            // this.$router.push("/courselist");
            this.$router.go('/');
          })
          .catch(err => {
            console.log(err.response);
          });
        },

        updatebusinessshowon(courseid,showstatus)
        {
          this.$http

          .post(this.$apidomain+"updatebusinesscourseshowon/"+courseid+'/'+this.id,{showon:showstatus})
          .then(res => {
            //this.businesses = res.data.businesses;
            // this.$router.push("/courselist");
            this.$router.go('/');
          })
          .catch(err => {
            console.log(err.response);
          });
        },




        dataURLtoFile(dataurl, filename)
        {

                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, {type:mime});
        },
        updateimage()
        {
            let fd = new FormData(document.getElementById("editfooditem"));

            if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
            }

            this.overlayfooditemimageupdate=true;

             this.$http
            .post(this.$apidomain+"updateItemImage/"+this.itemupdateid, fd)
            .then(res => {
                if(res.data.success==1)
                {

                    this.itemimagedialog=false;
                    this.overlayfooditemimageupdate=false;


                    // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                    // this.$router.push({name:'businessfoodlist'});
                    this.$router.go('/');

                }
                else
                {
                    this.overlay=false;
                    this.itemimagedialog=false;

                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    alert(errmsg[0]);
                }
            })
            .catch(err => {
                    this.overlay=false;

                    console.log(err.response);
            });

        },
        fooditemimage(fiid,crid,showonmenu)
        {

            // alert('fiid '+fiid+" crid "+crid+" show "+showonmenu);

            // if(this.itemdialog)
            // {
            //     this.itemdialog=false;
            // }
            // if(this.orderdialog)
            // {
            //     this.orderdialog=false;
            // }
            this.itemimagedialog=true;
            this.itemupdateid=fiid;
            this.itemupdatecourseid=crid;
            this.fooditemshowonmenu=showonmenu;


        },
        uploadImage(event)
        {
          // Reference to the DOM input element
          var input = event.target;
          // Ensure that you have a file before attempting to read it
          if (input.files && input.files[0]) {
                        this.mainimguploading=true;

              // create a new FileReader to read this image and convert to base64 format
              var reader = new FileReader();
              // Define a callback function to run, when FileReader finishes its job
              reader.onload = (e) => {
                  // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                  // Read image as base64 and set to imageData
                  this.uploadedimage = e.target.result;
              }
              // Start the reader job - read file as a data url (base64 format)
              reader.readAsDataURL(input.files[0]);
          }
        },
        onChange({coordinates, canvas})
        {

			      this.coordinates = coordinates
			      // You able to do different manipulations at a canvas
			      // but there we just get a cropped image
            this.image = canvas.toDataURL()
            this.mainimguploading=false;

        },
        backtomenuimage()
        {
            this.itemimagedialog=false;


        },
    updateshowitem(itemid, courseid, showitem) {
      this.overlay = true;

      //  let showitem=showitem;
      //showitem= document.getElementById('showonitem-'+itemid).value;

      // console.log('show item value ' + showitem+' itemid '+itemid);

      this.$http
        .post(
          this.$apidomain + "updateitemcourseshow/" + itemid + "/" + courseid,
          { showitem: showitem }
        )
        .then((res) => {
          if (res.data.success == 1) {
            this.$http
              .get(this.$apidomain + "itemlist/" + this.id)
              .then((res) => {
                if (res.data.success == 0) {
                  //this.$router.push({name:'businesslistnew'});
                }
                this.items = res.data.items;
                this.$http
                  .get(this.$apidomain + "getfooditems/" + this.id)
                  .then((res) => {
                    if (res.data.success == 0) {
                      //this.$router.push({name:'businesslistnew'});
                    }
                    this.fooditems = res.data.fooditems;
                    this.overlay = false;
                  })
                  .catch((err) => {
                    console.log(err.response);
                    this.overlay = false;
                  });
                // this.overlay=false;
              })
              .catch((err) => {
                console.log(err.response);
                this.overlay = false;
              });
          }
        })
        .catch((err) => {
          console.log(err.response);
          this.overlay = false;
        });
    },

    savemenu() {
      this.overlay = true;

      this.$http
        .post(this.$apidomain + "savebusinessfoodmenu", {
          data: JSON.stringify(this.fooditems),
          businessid: this.id,
        })
        .then((res) => {
          if (res.data.success == 1) {
            this.isdragged = 0;
            this.savemsg = res.data.msg;
            this.items = res.data.items;
            this.$http
              .get(this.$apidomain + "getfooditems/" + this.id)
              .then((res) => {
                if (res.data.success == 0) {
                  //this.$router.push({name:'businesslistnew'});
                }
                this.fooditems = res.data.fooditems;
                this.overlay = false;
              })
              .catch((err) => {
                console.log(err.response);
                this.overlay = false;
              });
          }
          // this.fooditems = res.data.fooditems
          // this.overlay=false;
        })
        .catch((err) => {
          console.log(err.response);
          this.overlay = false;
        });
    },
    dragfooditem(dtype) {
      this.isdragged = 1;
      this.savemsg = "";
      if (dtype == "c") {
        this.drag = 0;
      }

      if (dtype == "i") {
        this.dragitem = 0;
      }
    },


    deleteItem(fooditemid) {
      if (confirm("Are you sure you want to delete this Items?")) {
        this.overlay = true;

        this.$http
          .post(this.$apidomain + "deleteitem/" + fooditemid)
          .then((res) => {
            this.$http
              .get(this.$apidomain + "itemlist/" + this.id)
              .then((res) => {
                if (res.data.success == 0) {
                  //this.$router.push({name:'businesslistnew'});
                }
                this.items = res.data.items;
                this.$http
                  .get(this.$apidomain + "getfooditems/" + this.id)
                  .then((res) => {
                    if (res.data.success == 0) {
                      //this.$router.push({name:'businesslistnew'});
                    }
                    this.fooditems = res.data.fooditems;
                    this.overlay = false;
                  })
                  .catch((err) => {
                    console.log(err.response);
                    this.overlay = false;
                  });
                this.overlay = false;
              })
              .catch((err) => {
                console.log(err.response);
                this.overlay = false;
              });
          })
          .catch((err) => {
            console.log(err.response);
          });
      }
    },
    deleteItemCourse(itemcourseid) {
      if (confirm("Are you sure you want to delete this Items?")) {
        this.overlay = true;

        this.$http
          .post(this.$apidomain + "deleteitemcourse/" + itemcourseid)
          .then((res) => {
            this.$http
              .get(this.$apidomain + "itemlist/" + this.id)
              .then((res) => {
                if (res.data.success == 0) {
                  //this.$router.push({name:'businesslistnew'});
                }
                this.items = res.data.items;
                this.$http
                  .get(this.$apidomain + "getfooditems/" + this.id)
                  .then((res) => {
                    if (res.data.success == 0) {
                      //this.$router.push({name:'businesslistnew'});
                    }
                    this.fooditems = res.data.fooditems;
                    this.overlay = false;
                  })
                  .catch((err) => {
                    console.log(err.response);
                    this.overlay = false;
                  });
                this.overlay = false;
              })
              .catch((err) => {
                console.log(err.response);
                this.overlay = false;
              });
          })
          .catch((err) => {
            console.log(err.response);
          });
      }
    },
  },
};
</script>
<style scoped>
.createitemdialog .carddetail
    {
        /* color:white !important; */
        /* background: rgb(231, 231, 231) !important; */
        /* border-top-right-radius: 100px !important; */
        /* border-bottom-left-radius: 100px !important; */
        text-decoration: none;


    }
.mainhomecontainer .cardlist {
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.mainhomecontainer .cardlistnone {
  max-width: 100px !important;
  max-height: 75px !important;
  border-radius: none;
  border: none !important;
  box-shadow: none !important;
}

.mainhomecontainer .cardlistdnd {
  /* max-width: 960px; */
  max-height: 150px;
  border-top-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  width: 5vw;
  overflow: hidden;
}

.mainhomecontainer .cardlistheading {
  max-width: 400px;
  /* border-radius:none; */
  border: none !important;
  box-shadow: none !important;
  background-color: crimson !important;
}

.food-title-dnd {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: rgb(26, 26, 26) !important;
  text-transform: uppercase !important;
  padding-top: 1px !important;
  padding-bottom: 0px !important;
  line-height: 1;
}

.food-subtitle-dnd {
  padding-top: 1px !important;
  padding-bottom: 0px !important;
  color: rgb(26, 26, 26) !important;
  font-size: 12px !important;
  font-weight: 300 !important;
  line-height: 1;
  text-transform: capitalize !important;
  text-align: justify !important;
  /* line-height: 14px !important; */
  padding-left: 0px !important;
}

.food-strapline-dnd {
  padding-top: 1px;
  padding-bottom: 0px;
  color: rgb(26, 26, 26);
  font-size: 10px;
  font-weight: 100;
  text-transform: capitalize;
  text-align: justify;
  /* font-style: italic; */
  /* line-height: 12px; */
  padding-left: 0px !important;
}

.food-title-dnd-hidden {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: rgb(158, 158, 158) !important;
  text-transform: uppercase !important;
  padding-top: 1px !important;
  padding-bottom: 0px !important;
  line-height: 1;
}

.food-subtitle-dnd-hidden {
  padding-top: 1px !important;
  padding-bottom: 0px !important;
  color: rgb(221, 221, 221) !important;
  font-size: 12px !important;
  font-weight: 300 !important;
  line-height: 1;
  text-transform: capitalize !important;
  text-align: justify !important;
  /* line-height: 14px !important; */
  padding-left: 0px !important;
}

.food-strapline-dnd-hidden {
  padding-top: 1px;
  padding-bottom: 0px;
  color: rgb(221, 221, 221) !important;
  font-size: 10px;
  font-weight: 100;
  text-transform: capitalize;
  text-align: justify;
  /* font-style: italic; */
  /* line-height: 12px; */
  padding-left: 0px !important;
}

.maxtall {
  max-height: 100%;
}

.price-row {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.foodtitle {
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  text-transform: uppercase;
}
.cardlist {
  border-radius: 5px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 50px;
  background-color: rgb(252, 252, 252);
}
.move {
  cursor: nesw-resize;
}
.overflowcol {
  flex-shrink: 0;
}
.course_col {
  width: 360px;
  /* float:left; */
  padding: 15px;
}
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  /*width: 100%;
  max-width: 100%;*/
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}

.seperator {
  background-color: rgb(68, 68, 68) !important;
  border-radius: 0px;
}

.cogmenu {
  z-index: 9999;
}

.alignrigth {
  text-align: right;
  justify-content: flex-end;
}

.compact-form {
  transform: scale(0.75);
  transform-origin: right;
}


.inactivecogsimg {
  color: rgb(158, 158, 158) !important;
  /* opacity: .75; */
  /* color: rgb(176, 176, 176) !important; */
}

.dnd-card-height {
  max-height: 100px;
}
.course-heading {
  justify-content: center !important;
}
.section-spread {
  justify-content: space-between;
}
.nothing {
  padding: 0% !important;
  margin: 0% !important;
  border: none !important;
  box-shadow: none !important;
  box-sizing: none !important;
  color: red !important;
}
.column-header {
  text-align-last: justify;
}
.course-heading-card {
  border-radius: 0px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  background-color: #fe5800 !important;
  color: white !important;
}
.course-heading-card-inactive {
  border-radius: 0px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  background-color: #b3b3b3 !important;
  color: rgb(48, 48, 48) !important;
}
.course-banner-card {
  border-top: 0px;
  border-radius: 3px !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-left: 1px;
  border-right:1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #FE5800 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.course-banner-card-inactive {
  border-top: 0px;
  border-radius: 3px !important;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-left: 1px;
  border-right:1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #b3b3b3 !important;
  background-color: #ffffff !important;
  color: #000000 !important;
}
.compact-toggle-dnd-1 {
  transform: scale(0.75);
  transform-origin: right;
}
.white-cog{
  color: white !important;
}
.hidden-text-heading {
  color: rgb(158, 158, 158) !important;
  font-weight: 600 !important;
}
.white-text-heading {
  color: white !important;
  font-weight: 600 !important;
  text-decoration: none;
}
.courseheading {
  font-size: 24px !important;
  font-weight: 600;
  text-align: center;
  border-radius: 0px !important;
  text-transform: uppercase;
}

.food-course-top-banner-title{
        font-size: 16px;
        font-weight: 600;
        padding-bottom: 5px;
        text-align: center !important;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        margin-top: 10px;
    }

.food-course-top-banner-price{
        font-size: 12px;
        font-weight: 600;
        color: #333333;
        text-align: center !important;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

.food-course-top-banner-price-text{
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        text-align: center !important;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

.food-course-top-banner-description{
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        color: #333333;
        text-align: center !important;
        padding-top: 0px;
        padding-bottom: 5px;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 10px;
        margin-top: 10px;

    }
    .cog-position-1{
      position: absolute;
      bottom: -9px;
      left: -1px;
    }
    .align-end{
      justify-content: flex-end;
    }
.edit-item-name{
        font-weight: 600 !important;
        font-size: 14px;
        color: #FE5800;
        padding-top: 25px !important;
        margin-top: 25px !important;
        /* font-size: x-small !important; */
    }
.addnew{
  font-size: 100;
  font-weight: 400;
  color: #FE5800;
  padding-top: 25px;
  flex: auto;
  align-content: flex-end;
}

.addnewicon{
  color: #fe5800;
}
.chef-selected{
  /* background-color:red; */
  /* font-size: 500; */
  color: rgb(0, 0, 0) !important;
  width: 100%;

}

.cheficonDnD{

        position: absolute;
        top: -3px;
        right: 25px;
        width: 30px;
        z-index: 3;
        -webkit-animation: none;
        animation: none;
        -webkit-transform-origin: none;
        transform-origin: none;
        -webkit-transform: none;
        transform: none;

    }
.featueredDnD{
    /* border-color: #FE5800 !important; */

    border-style: outset !important;
    border-width: thick !important;
    border-radius: 0px !important;
    border-color: #FE5800;

}
.hidden-course{
  opacity: .3 !important;
}
.inactiveimg {
  opacity: 0.2 !important;
}
.left-right-arrow{
  font-size: 10px;
}
.sticky-course-heading{
  position: fixedHeader;
  /* top: 0px; */
}
.centered-text{
  text-align: center !important;
}


.true-center{
  display: grid;
  place-items: center;
}
.cropper-replace {
  border: solid 1px #eee;
  height: 400px;
  width: 600px;
}
</style>
